import axios from "axios";
import Vue from "vue";
import authHeader from "@/services/auth-header";
import config from "@/data/config";

const API_URL = config.baseURL;

export const masterWilayah = {
   namespaced: true,
   state: {
      data: [],
   },
   getters: {
      // countAll: (state) => {return state.data.length},
      countAll(state) {
         return state.data.length;
      },
      getById: (state) => (id) => {
         return state.data.find((data) => data.id === id);
      },
   },
   actions: {
      getAll({ commit, rootState }) {
         rootState.isLoading = true;
         axios.get(`${API_URL}wilayah`, { headers: authHeader() }).then(
            (response) => {
               commit("SET_DATA", response.data);
               rootState.isLoading = false;
            },
            () => {
               rootState.isLoading = false;
            }
         );
      },
      insert({ commit, rootState }, data) {
         rootState.isLoading = true;
         return axios
            .post(`${API_URL}wilayah`, data, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  commit("PUSH_ITEM", response.data);
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      update({ commit, rootState }, data) {
         rootState.isLoading = true;
         return axios
            .put(`${API_URL}wilayah/${data.id}`, data, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  commit("CHANGE_ITEM", response.data);
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      delete({ commit, rootState }, id) {
         rootState.isLoading = true;
         return axios
            .delete(`${API_URL}wilayah/${id}`, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  commit("REMOVE_ITEM", id);
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
   },
   mutations: {
      SET_DATA(state, data) {
         state.data = data;
      },
      PUSH_ITEM(state, item) {
         state.data.push(item);
      },
      CHANGE_ITEM(state, payload) {
         console.log(payload);
         const index = state.data.findIndex((item) => item.id === payload.id);
         if (index !== -1) {
            Vue.set(state.data, index, payload);
         }
      },
      REMOVE_ITEM(state, id) {
         var i = state.data.findIndex((data) => data.id == id);
      
         state.data.splice(i, 1);
      },
   },
};
